import React from "react";
import { Button, Card } from "react-bootstrap";
import { BulkActionsBarProps } from '@features/invitations/types/bulkActionsBarProps';

const BulkActionsBar: React.FC<BulkActionsBarProps> = ({ count, onCancelMany, onResendMany, onClearSelection }) => {

    // Don't render if no items are selected
    if (count === 0) return null;

    return (
        <Card className="mb-2 border-0" data-testid="bulk-actions-bar">
            <Card.Body className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center py-2 gap-2">
                <div className="text-muted mb-2 mb-md-0" data-testid="selected-count">
                    <strong>{count}</strong> selected
                </div>
                <div className="d-flex flex-column flex-md-row gap-2">
                    <Button
                        variant="outline-light"
                        size="sm"
                        className="text-muted text-decoration-none px-0 px-md-2 border border-subtle-dark text-dark"
                        onClick={onClearSelection}
                        aria-label="Clear selection"
                        data-testid="clear-selection-btn"
                    >
                        Clear
                    </Button>
                    <Button
                        variant="outline-danger"
                        size="sm"
                        className="me-0 me-md-2"
                        onClick={onCancelMany}
                        data-testid="cancel-selected-btn"
                    >
                        Cancel Selected
                    </Button>
                    <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={onResendMany}
                        data-testid="resend-selected-btn"
                    >
                        Resend Selected
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );
}

export default BulkActionsBar;